import { combineReducers } from "redux";
import { toggleEntity, companySetupId } from "./toggleEntity";

const emailTextAlert = combineReducers({
  toggleEntity,
  companySetupId
});

export default emailTextAlert;
